import isNumber from './is-number';
var isOdd = function (num) {
    return isNumber(num) && num % 2 !== 0;
};
export default isOdd;
//# sourceMappingURL=is-odd.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-odd.js
// module id = 498
// module chunks = 3